import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiService } from '../services/api';
import { Client } from '../types';
import UserProfile from './UserProfile';

const Sidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [client, setClient] = useState<Client | null>(null);

  // If on /clients/:clientId, fetch that client
  useEffect(() => {
    const match = location.pathname.match(/^\/clients\/(.+)$/);
    if (match && match[1]) {
      apiService.getClientOverview(match[1])
        .then(overview => setClient(overview.client))
        .catch(() => setClient(null));
    } else {
      setClient(null);
    }
  }, [location.pathname]);

  return (
    <aside
      style={{
        width: 270,
        background: '#fff',
        paddingTop: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingBottom: 16,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 100,
        boxSizing: 'border-box',
        overflowX: 'hidden',
      }}
    >
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 32 }}>
        </div>
        {client ? (
          <>

            {/* Back button */}
            <button
              onClick={() => navigate('/clients')}
              style={{
                background: 'none',
                border: 'none',
                color: '#2563eb',
                fontWeight: 500,
                fontSize: 15,
                cursor: 'pointer',
                padding: 0,
                textAlign: 'left',
                marginBottom: 24,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <ArrowBackIosOutlinedIcon style={{ fontSize: 18, marginRight: 6 }} /> Back
            </button>

            <nav style={{ display: 'flex', flexDirection: 'column', gap: 12, flex: 1, overflowY: 'auto', overflowX: 'hidden', paddingRight: 8 }}>
              <a
                href="#client-overview"
                style={{
                  color: '#111',
                  textDecoration: 'none',
                  fontWeight: 500,
                  padding: '6px 0',
                  transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: 'translateX(0)',
                  borderRadius: '6px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateX(6px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
              >
                Client Overview
              </a>
              <a
                href="#project-status"
                style={{
                  color: '#111',
                  textDecoration: 'none',
                  fontWeight: 500,
                  padding: '6px 0',
                  transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: 'translateX(0)',
                  borderRadius: '6px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateX(6px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
              >
                Project Status
              </a>
              <a
                href="#general-insights"
                style={{
                  color: '#111',
                  textDecoration: 'none',
                  fontWeight: 500,
                  padding: '6px 0',
                  transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: 'translateX(0)',
                  borderRadius: '6px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateX(6px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
              >
                General Insights
              </a>
              <a
                href="#client-voice"
                style={{
                  color: '#111',
                  textDecoration: 'none',
                  fontWeight: 500,
                  padding: '6px 0',
                  transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: 'translateX(0)',
                  borderRadius: '6px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateX(6px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
              >
                Client Voice
              </a>
              <a
                href="#whats-next"
                style={{
                  color: '#111',
                  textDecoration: 'none',
                  fontWeight: 500,
                  padding: '6px 0',
                  transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: 'translateX(0)',
                  borderRadius: '6px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateX(6px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
              >
                What's Next
              </a>
            </nav>
          </>
        ) : location.pathname === '/clients' ? (
          <>
            <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 16 }}></div>
          </>
        ) : null}
      </div>
      <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
        <UserProfile />
      </div>
    </aside>
  );
};

export default Sidebar; 